<template>
  <section class="pd-y-30" style="background: #F7FAFF">
    <div class="container" style="max-width: 600px !important">
      <div class="section-title">
        <h2>{{ comp.task }}</h2>
        <p>{{ comp.f1 }}</p>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <!-- 35572 -->
        <div
          class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
          v-for="(t, i) in tasks"
          :key="i"
        >
          <div class="">
            <a v-if="$store.state.app.activeGroup.publicPage.readUrl!==undefined 
            && $store.state.app.activeGroup.publicPage.readUrl!==''"
            target="_blank" :href="`${$store.state.app.activeGroup.publicPage.readUrl}/c/${$store.state.app.contentPageId}?cid=${t.id}`">
              <img style="border-radius: 10px;"
                :src="`${t.defaultAttachmentUrl}?w=460&h=280&mode=crop`"
                class="card-img wd-100p"
              />
              <div class="card-body">
                <h5 class="card-title text-truncate-2">{{ t.task }}</h5>
                <div class="text-orange">
                  {{ t.createdDate | moment("YYYY.MM.DD") }}
                </div>
              </div>
            </a>
            <router-link v-else
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: {
                  id: $store.state.app.contentPageId,
                  cid: t.id
                }
              }"
            >
              <img
                :src="`${t.defaultAttachmentUrl}?w=460&h=360&mode=crop`"
                class="card-img wd-100p"
              />
              <div class="card-body">
                <h5 class="card-title text-truncate-2">{{ t.task }}</h5>
                <div class="text-orange">
                  {{ t.createdDate | moment("YYYY.MM.DD") }}
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tasks: []
    };
  },
  mounted() {
    this.loadTasks(this.comp.locTypeId1);
  },
  methods: {
    loadTasks(typeId) {
      //console.log('=>', this.comp);
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 3,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: typeId
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks = res.data.tasks;
        }
      });
    }
  }
};
</script>

<style>
.text-truncate-2 {
  overflow:hidden;
  font-weight: 600;
  color: rgb(31, 41, 55);
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
